<template>
  <!-- 多级业务员迁移下级 -->
  <div class="DuoJiSalesChangeTransfer ">
    <!-- 面包屑导航 -->
    <page-bar @back="goBack" @refresh="handleRefresh" :title="$route.meta.title">
      <!-- <template slot="controls">
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="getLeaderList('')">更换上级</el-button>
      </template> -->
    </page-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input v-model="searchForm.name" style="width: 200px; margin-right: 5px" clearable placeholder="输入姓名"
          @keyup.enter.native="getTableData(1)"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">搜索</el-button>
      </template>
    </search-bar>
    <!-- 展示下级列表 -->
    <el-table
      :data="leaderList"
      stripe border
      height="calc(100% - 130px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <!-- <el-table-column type="selection" align="center" width="55">
      </el-table-column> -->
      <el-table-column prop="userId" label="用户id" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="name" label="姓名" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="username" label="用户名" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="telphone" label="电话" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="rankname" label="级别" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="add_time" label="时间" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="changeTransfer(scope.row.userId)"
          >业务员迁移下级
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
//表单验证
// import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "DuoJiSalesChangeTransfer",
  data() {
    return {
      id: "",
      searchForm: {
        name: "",
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [],
      // 数据选择
      dialogVisible: false,
      loading: false, //加载
      searchUser: "", //弹窗
      leaderList: [], //上级业务员列表
      //表格下面分页
      userIds: "", //勾选的业务员
      currentPage: 1,
      totalnumber: 0, //总条数
      pagesize_value: 25, //默认设置页数量
      currentchange_vlue: 1, //总页码
      pagesize: [25, 50, 100, 200],
      userId: "",
    };
  },
  created() {
  },
  mounted() {
    if (this.$route.query.prams) {
      try {
        // 先base64解码再JSON解析
        const decoded = atob(this.$route.query.prams);
        const prams = JSON.parse(decoded);

        // 参数使用
        this.userId = prams.managerId;
        this.getTableData(1, this.userId);

      } catch (e) {
        console.error('参数解析失败:', e);
      }
    } else {
      console.warn('未接收到prams参数');
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    /**获取平级列表 */
    getTableData(num, userId) {
      this.userId = userId || this.userId; // 优先使用传入的userId
      this.currPage = num == 1 ? 1 : this.currPage;
      let jsonData = {
        managerId: this.userId,
        type: "singlelevel",
        relation:'平级',
        name: this.searchForm.name || "",
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      };
      let encodedJson = encodeURIComponent(JSON.stringify(jsonData));
      this.$request({
        url: `Admin/manage/ashx/ReturnJson.ashx?type=ReturnList&json=${encodedJson}&proc=Proc_ManagerRelation`,
        method: "get",
      })
        .then((res) => {
          if(res.flag == 0){
            this.leaderList = res.data || []
            .map(item => ({
              ...item,
              name: item.name || ''
            }))
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**业务员迁移下级 */
    changeTransfer(id) {
      this.$confirm("确定业务员降级吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          let ids = []
          ids = id || this.selectedList.map((item) => item.userId).join(",");
          const jsonData1 = {
            type: 'migration',
            managerId: this.userId,
            senior: ids,
          };
          let encodedJson1 = encodeURIComponent(JSON.stringify(jsonData1));
          this.$request({
            url: `Admin/manage/ashx/ReturnJson.ashx?type=ReturnNumber&json=${encodedJson1}&proc=Proc_ManagerRelation`,
            method: "get",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "更换上级成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    //弹窗
    getLeaderList() {
      this.dialogVisible = true;
      this.searchUser = "";
      this.userId = "";
      this.search();
    },
    //页数选择
    getsizechange(val) {
      let _this = this;
      this.currentchange_vlue = 1;
      _this.pagesize_value = val;
      // this.getGoodsLists();
    },
    //选择分页页数
    getcurrentchange(val) {
      let _this = this;
      _this.currentchange_vlue = val;
      // this.getGoodsLists();
    },
    // 选择单条数据
    // rowClick(section) {
    //   console.log('section',section);
    //   this.userId = "";
    //   for (var i = 0; i < section.length; i++) {
    //     this.userId += section[i].userId + ",";
    //   }
    //   console.log('选择的业务员',this.userId);
    // },
  }
};
</script>

<style scoped>
.DuoJiSalesChangeTransfer {
  width: 100%;
  height: 100%;
}
</style>
